import { onChangeField, onClearForm } from "components/common";
import { parseQueryParams, stringifyQueryParams } from "components/common";

const onChangeSearch = ({ queryParams, history }) => (paramName, paramValue) => {
  const parsedParams = parseQueryParams(queryParams);
  const filteredParams = Object.entries(parsedParams)
    .filter(([key, value]) => !key.toLowerCase().includes("page"))
    .reduce((obj, [key, value]) => {
      obj[key] = parsedParams[key];
      return obj;
    }, {});

  const newQueryParams = {
    ...filteredParams,
    [paramName]: paramValue,
  };

  history.push(location.pathname + "?" + stringifyQueryParams(newQueryParams));
};

const onClearSearch = ({ history }) => () => {
  history.push(location.pathname);
};

export const handleChangeSearchFormField = ({ dispatch, search, history }) => (field, value) => {
  if (value !== undefined) {
    return onChangeField(dispatch, onChangeSearch({ queryParams: search, history }))(field)(value);
  }
  return onChangeField(dispatch, onChangeSearch({ queryParams: search, history }))(field);
};

export const handleClearSearchForm = ({ dispatch, history }) => () => {
  onClearForm(dispatch, onClearSearch({ history }));
};
